import { Grid, SvgIcon, Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'

import star from '@hapana/shared/web/styles/assets/svgs/star.svg'
import useSiteStore from '_stores/site.store'

import { styles } from './badges.styles'
import { getMileStone } from './badges.util'

const Badges = ({ checkInDate, totalCheckInCount, siteInformation, isSuccess }) => {
  const siteId = useSiteStore((state) => state.currentSite?.siteId)

  const sameSiteInformation = siteInformation?.find((s) => s.siteId === siteId)

  const checkInCount = sameSiteInformation?.checkInCount
  const lastCheckInOn = sameSiteInformation?.lastCheckInOn

  const hasToIncrement = isSuccess && (!sameSiteInformation || lastCheckInOn < checkInDate)

  const siteBadge = (checkInCount ?? 0) + (hasToIncrement ? 1 : 0)
  const corporateBadge = (totalCheckInCount ?? 0) + (hasToIncrement ? 1 : 0)

  return (
    <Grid container sx={styles.badgesWrapper}>
      <Grid item sx={styles.badgeItem}>
        <Box sx={styles.countWrapper}>
          <Typography typography="header5" color="gray.0">
            {getMileStone(siteBadge)}
          </Typography>
        </Box>
        <Box sx={styles.iconWrapper}>
          <SvgIcon sx={styles.locationMilestone} component={star} viewBox="0 0 28 28" />
        </Box>
      </Grid>
      <Grid item>
        <Box sx={styles.countWrapper}>
          <Typography typography="header5" color="gray.0">
            {getMileStone(corporateBadge)}
          </Typography>
        </Box>
        <Box sx={styles.iconWrapper}>
          <SvgIcon sx={styles.attendanceMilestone} component={star} viewBox="0 0 28 28" />
        </Box>
      </Grid>
    </Grid>
  )
}

Badges.propTypes = {
  checkInDate: PropTypes.string,
  totalCheckInCount: PropTypes.number,
  siteInformation: PropTypes.array,
  isSuccess: PropTypes.bool,
}

export default Badges
